/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import { Button, Card, Modal, Row, Col, Checkbox, Radio } from "antd";
import moment from "moment";
import { Pie, Bar } from "ant-design-pro/lib/Charts";
import TimelineChart2 from "../../components/TimelineChart";
import Nis from "../../components/Nis";
import LangContext from "../../contextProvider/LangContext";
import "../Dashboard.css";
import { Job, OutputType, ProcessType, User } from "../../JmReact";
import { findIndex } from "lodash";

class SegmentationSection extends Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isMonthlySalesGraphExtended: false,
            isHourlySalesGraphExtended: false,
            isPaymentsGraphExtended: false,
            stateMobile: 'tab1',

            hourly: { data: [], yCount: 0, titleMap: {} },
            payments: [],
            monthly: [],

        }

        this.shortPos_id = "SELECTOR_SHORT_POS";
        this.catering_id = "CATERING_TICKETS_DATA";

        if (props.data[this.shortPos_id] === undefined) props.data[this.shortPos_id] = { ...props.data.genericSelector }
        if (props.data[this.catering_id] === undefined) props.data[this.catering_id] = { ...props.data.genericData }
    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {
        this.props.dataActions.genericSelectorRefreshDataset(
            this.shortPos_id, this.props.user.companyCode, this.props.user.token, "list_short_pos");
    }

    componentDidUpdate(p) {
        const { dashboardPos, dashboardDate, dashboardHour, graphHoursPerPos, firstLoading } = this.props
        const endDay = d => moment(d).add(1, "day").add(-1, "second").format("YYYY-MM-DD HH:mm:ss")
        const _today = moment(dashboardDate).format("YYYY-MM-DD") + " " + dashboardHour
        let dataSend = 'posList\ffromDatetime\ftoDatetime\fgraphHoursPerPos\r' + dashboardPos + "\f" + _today + "\f" + endDay(_today) + "\f" + graphHoursPerPos

        if (p.firstLoading !== firstLoading) {
            // if (p.dashboardDate !== dashboardDate || p.dashboardPos !== dashboardPos || p.dashboardHour !== dashboardHour || p.graphHoursPerPos !== graphHoursPerPos) {
            this.sendAPI("dashboard_get_hourly", dataSend, ob => {
                let posList = []
                let yCount = 0;
                let posLegend = {}
                let minHour = null
                let maxHour = null
                let hourlyData = []
                let fullData = ob.data ? ob.data.split("\r").map((x, i) => {
                    const [_hour, _pos, _posName, _sum] = x.split("\f")
                    if (posList.findIndex(f => f == _pos) === -1) {
                        posList.push(_pos)
                        yCount++
                        posLegend = { ...posLegend, ['y' + yCount]: _posName }
                    }

                    if (i == 0) minHour = parseInt(_hour)
                    maxHour = parseInt(_hour)
                    return { _hour, _pos, _sum }
                }) : []

                for (let x = minHour; x <= maxHour; x += 3600000) {
                    let res = { x: x }
                    posList.forEach((y, i) => { res = { ...res, ['y' + (i + 1)]: 0 } })
                    hourlyData.push(res)
                }

                fullData.forEach(x => {
                    let findHour = hourlyData.findIndex(f => f.x == x._hour)
                    let findPos = posList.findIndex(f => f == x._pos)
                    if (findHour > -1 && findPos > -1) hourlyData[findHour]['y' + (findPos + 1)] = parseInt(x._sum) > 0 ? parseInt(x._sum) : 0
                })

                console.log("paymentsContent", { hourlyData, yCount, posLegend })
           
                this.setState({ hourly: { data: hourlyData, yCount, titleMap: posLegend } })
            })
        }


        if (p.firstLoading !== firstLoading) {
            // if (p.dashboardDate !== dashboardDate || p.dashboardPos !== dashboardPos || p.dashboardHour !== dashboardHour) {

            this.sendAPI("dashboard_get_payments", dataSend, ob => {
                this.setState({
                    payments: ob.data ? ob.data.split("\r").map(x => {
                        let y = x.split("\f")
                        return { x: y[0], y: parseFloat(y[1]) }
                    }) : []
                })
            })

            this.sendAPI("dashboard_get_monthly", dataSend, ob => {
                let monthlyMax = 0;
                let monthlyData = ob.data ? ob.data.split("\r").map(_d => {
                    const d = _d.split("\f")
                    let x = parseInt(d[0])
                    let y = parseFloat(d[1])
                    monthlyMax = x
                    return { x, y }
                }) : []

                let monthly = [];
                for (let x = 0; x <= monthlyMax; x++) {
                    let yf = monthlyData.find(f => f.x == x)
                    monthly.push({ x, y: yf ? yf.y : 0 })
                }

                this.setState({ monthly })
            })
        }
    }

    sendAPI = (script, data, sCallback) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType["OUTPUT_TYPE_DATA"], ProcessType["PROCESS_TYPE_SYNC"]);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCallback, (e) => { console.error(e) });
    }

    getCard = (title, content, stateName) => {
        let isExtended = this.state[stateName];

        let footer = (<Button
            htmlType={"button"} style={{ marginTop: 8 }}
            onClick={() => { this.setState({ [stateName]: !isExtended }) }}
        >{this.getText(isExtended ? 10134 : 10122)}</Button>);

        return (<Col xl={8} lg={12} md={24} sm={24} xs={24} style={{ marginBottom: "24px" }}>
            <Card loading={this.props.isLoading} bordered={false} title={title} bodyStyle={{ padding: 24, direction: "ltr" }}>
                {content}{footer}
            </Card>
        </Col>)
    }

    getModal = (title, content, stateName) => {
        return (<Modal title={title} centered onCancel={() => { this.setState({ [stateName]: false }) }} visible={this.state[stateName]} footer={null} width={800}>
            {content}
        </Modal>)
    }

    // getShortNamePos = (num) => {
    //     let shortPos = this.props.data[this.shortPos_id].dataset.find(f => f.code == num);
    //     return shortPos ? shortPos['name'] : false
    // }

    getSum = (sum) => {
        return ((parseFloat(sum) ? parseFloat(sum) : 0) / (this.props.currencyValue ?? 1)).toFixed(0) + " " + this.props.currencySymbol
    }

    render() {
        // const { monthly, pos, hourly, payments } = this.props.apiData;
        let gt = this.getText;

        // let isPerPos = this.props.graphHoursPerPos == 1;
        // let hourlyData = hourly.map((x) => {
        //     let k = Object.keys(x);
        //     let obj = { ...x }
        //     let y1 = 0;
        //     k.forEach((y) => {
        //         if (y !== 'x') {
        //             let value = (obj[y] < 0) ? 0 : Math.round(obj[y])
        //             obj[y] = value;
        //             y1 += value;
        //         }
        //     });
        //     return isPerPos ? obj : { x: obj.x, y1 };
        // });

        // let countHourly = 1;
        // let posLegend = { y1: '' };

        // if (isPerPos) {
        // countHourly = pos.length;
        // posLegend = {};

        // pos.forEach((x, i) => {
        // let shortName = this.getShortNamePos(x.key);
        // posLegend["y" + (i + 1)] = shortName ? shortName : gt(10061) + " " + x.key
        // });
        // }

        let cateringDataParTag = [];

        let cateringData = this.props.data[this.catering_id] ?
            this.props.data[this.catering_id].data.map(((x) => {
                let y = x.split('\f');
                let findTag = cateringDataParTag.findIndex(f => f.tag == y[2])
                if (findTag > -1) {
                    cateringDataParTag[findTag] = {
                        ...cateringDataParTag[findTag],
                        total: cateringDataParTag[findTag].total + parseFloat(y[1]),
                        data: [...cateringDataParTag[findTag].data, { x: y[0], y: parseFloat(y[1]) }]
                    }
                } else {
                    cateringDataParTag.push({
                        tag: y[2],
                        tagName: y[3],
                        total: parseFloat(y[1]) ?? 0,
                        data: [{ x: y[0], y: parseFloat(y[1]) }]
                    })
                }
                return { x: y[0], y: parseFloat(y[1]), tag: y[2], tagName: y[3] };
            })) : [];

        let piePaymentData = []

        if (this.props.viewPaysType != 2) piePaymentData = [...this.state.payments]
        if (this.props.viewPaysType != 1) piePaymentData = [...piePaymentData, ...cateringData]

        let paymentTotal = this.state.payments.reduce((pre, now) => now.y + pre, 0);
        let piePaymentTotal = piePaymentData.reduce((pre, now) => now.y + pre, 0);


        let monthlyContent = (height) => (<Bar height={height} title={""} data={this.state.monthly.map(x => { return { ...x, y: Math.round(x.y) } })} />)
        // let hourlyContent = (height) => (<TimelineChart2 height={height} data={hourlyData} yCount={countHourly} titleMap={posLegend} />)
        let hourlyContent = (height) => (<TimelineChart2 height={height} {...this.state.hourly} />)
        let paymentsContent = (height, data, subTitle, total) => {
            return (<div style={{ direction: "ltr" }}>
                <Pie
                    hasLegend subTitle={subTitle} data={data}
                    total={() => this.getSum(total)}
                    valueFormat={value => this.getSum(value)}
                    height={height} lineWidth={4} style={{ padding: '8px 0' }} />

            </div>)
        }

        let paySmall = (<div style={{ direction: "rtl" }}>
            <Radio.Group value={this.props.viewPaysType} onChange={this.props.viewPaysTypeChange}>
                <Radio value={'0'}>{this.getText(19334)}</Radio><br />
                <Radio value={'1'}>{this.getText(19335)}</Radio><br />
                <Radio value={'2'}>{this.getText(19336)}</Radio>
            </Radio.Group>
            {paymentsContent(270, piePaymentData, gt(10137), piePaymentTotal)}
        </div>);

        let payModal = (<div>
            {paymentsContent(500, piePaymentData, gt(10137), piePaymentTotal)}
            {this.props.viewPaysType == 0 ? paymentsContent(270, this.state.payments, "תקבולים", paymentTotal) : ""}
            {this.props.viewPaysType != 1 ? cateringDataParTag.map(x => paymentsContent(270, x.data, x.tagName, x.total)) : ""}

        </div>)

        let mobile = window.innerWidth <= 600;
        const { stateMobile } = this.state;


        return mobile ?
            (<Card
                style={{ marginBottom: 20, direction: "ltr" }}
                loading={this.props.isLoading}
                bordered={false}
                bodyStyle={{ padding: 24, direction: "ltr" }}
                activeTabKey={stateMobile}
                onTabChange={key => { this.setState({ stateMobile: key }) }}
                title={stateMobile === 'tab1' ? gt(10133) : stateMobile === 'tab2' ? gt(10135) : stateMobile === 'tab3' ? gt(10136) : ""}
                tabList={[
                    { key: 'tab1', tab: gt(16959) },
                    { key: 'tab2', tab: gt(16960) },
                    { key: 'tab3', tab: gt(16961) },
                ]}>
                {stateMobile === 'tab1' ? monthlyContent(295) : stateMobile === 'tab2' ? hourlyContent(265) : stateMobile === 'tab3' ? paySmall : ""}
            </Card>)
            :
            (<Row gutter={24}>
                {this.getCard(gt(10133), monthlyContent(295), 'isMonthlySalesGraphExtended')}
                {this.getCard(gt(10135), hourlyContent(265), 'isHourlySalesGraphExtended')}
                {this.getCard(gt(10136), paySmall, 'isPaymentsGraphExtended')}

                {this.getModal(gt(10150), monthlyContent(600), 'isMonthlySalesGraphExtended')}
                {this.getModal(gt(10151), hourlyContent(500), 'isHourlySalesGraphExtended')}
                {this.getModal(gt(10136), payModal, 'isPaymentsGraphExtended')}
            </Row>);

    }
}
export default SegmentationSection;
